'use client'

import EventCard from '@/app/(public)/components/cards/event-card'
import { useMemo, useState } from 'react'
import { getEventScheduleForSelectedSplits } from '../utils'
import SelectChampionshipSplitsButton from './select-championship-splits-button'

export default function EventsSchedule({
  championship,
  events,
  selectedSplits,
  setSelectedSplits,
}) {
  const [now] = useState(() => new Date())

  const scheduledEvents = useMemo(() => {
    if (!events || events.length === 0) return []
    if (championship.splits.length === 0) return events

    return events.map((event) =>
      getEventScheduleForSelectedSplits(event, selectedSplits),
    )
  }, [championship.splits.length, events, selectedSplits])

  const upcomingEvents = useMemo(() => {
    if (scheduledEvents.length === 0) return []
    return scheduledEvents
      .filter((event) => new Date(event.finishDateTime) > now)
      .reverse()
  }, [scheduledEvents, now])

  const previousEvents = useMemo(() => {
    if (scheduledEvents.length === 0) return []
    return scheduledEvents.filter(
      (event) => new Date(event.finishDateTime) <= now,
    )
  }, [scheduledEvents, now])

  const upcomingEmptyMessage =
    championship.splits.length > 0
      ? selectedSplits.length > 0
        ? 'No upcoming events for selected splits'
        : 'Select at least one split to view events'
      : 'No upcoming events'

  return (
    <div className="mt-6 desktop-xs:mt-8">
      <h4 className="font-inter text-h-4 font-semibold">Upcoming</h4>

      {championship.splits.length > 0 && (
        <div className="mt-5">
          <SelectChampionshipSplitsButton
            selectedSplits={selectedSplits}
            setSelectedSplits={setSelectedSplits}
            splits={championship.splits}
          />
        </div>
      )}

      <div className="screen-grid-no-padding mt-5 gap-y-5 desktop-xs:gap-y-[37px]">
        {upcomingEvents.length > 0 ? (
          upcomingEvents.map((event) => (
            <EventCard
              eventFromParent={{ ...event, championship }}
              selectedSplits={selectedSplits}
              key={event.id}
            />
          ))
        ) : (
          <div className="col-span-full flex h-[60px] items-center rounded-sm border border-neutral-blue-700 bg-neutral-blue-800 align-middle">
            <h5 className="mx-auto px-6 text-center">{upcomingEmptyMessage}</h5>
          </div>
        )}
      </div>

      {previousEvents.length > 0 && (
        <>
          <div className="divide mt-[60px] h-px bg-neutral-blue-700" />

          <h4 className="mt-5 font-inter text-h-4 font-semibold desktop-xs:mt-8">
            Finished
          </h4>

          <div className="screen-grid-no-padding desktop-xs:gap-y-[37px mt-5 gap-y-5">
            {previousEvents.map((event) => (
              <EventCard
                eventFromParent={{ ...event, championship }}
                selectedSplits={selectedSplits}
                key={event.id}
              />
            ))}
          </div>
        </>
      )}
    </div>
  )
}
